import * as React from "react";
import { ArrowUp, ArrowDown, CornerDownLeft } from "lucide-react";
import { useImpersonationDialogContext } from "../ImpersonationContext";
import { useMemo } from "react";

export const Footer: React.FC = () => {
  const { session } = useImpersonationDialogContext();
  const isMac = useMemo(() => {
    if (typeof window === "undefined") return true;
    return /Macintosh|Mac OS X/i.test(navigator.userAgent);
  }, []);

  return (
    <div className="h-10 bg-slate-50 border-t border-slate-100 flex items-center justify-between px-5 text-[10px] text-slate-400 font-semibold select-none shrink-0">
      <div className="flex items-center gap-4">
        <span className="flex items-center gap-1">
          <ArrowUp className="h-3.5 w-3.5 text-slate-400/80" />
          <ArrowDown className="h-3.5 w-3.5 text-slate-400/80" />
          <span>to navigate</span>
        </span>
        <div className="w-px h-3 bg-slate-200" />
        <span className="flex items-center gap-1">
          <CornerDownLeft className="h-3 w-3 text-slate-400/80" />
          <span>to switch accounts</span>
        </span>
      </div>
      {session?.actor ? (
        <span className="flex items-center gap-1 shrink-0">
          <kbd className="pointer-events-none inline-flex h-4.5 select-none items-center gap-0.5 rounded border bg-slate-100 px-1 font-mono text-[9px] font-bold text-slate-400 opacity-100">
            {isMac ? (
              <>
                <span className="text-xs">⌥</span>R
              </>
            ) : (
              <>Alt+R</>
            )}
          </kbd>
          <span>to return</span>
        </span>
      ) : (
        <span className="text-slate-400">esc to close</span>
      )}
    </div>
  );
};
